import React from 'react';


const VettingDownArrow = (props) => {

  return (
    <svg 
      className={`${props.direction}`}
      width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M7 11.9004L0 3.50039L14 3.50039L7 11.9004Z" fill="#4A4D4E" />
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="3" width="14" height="9">
        <path fillRule="evenodd" clipRule="evenodd" d="M7 11.9004L0 3.50039L14 3.50039L7 11.9004Z" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <rect width="14" height="14" fill="#282828" />
      </g>
    </svg>
  );
}



export default VettingDownArrow;